export default __webpack_public_path__ + "static/media/total_catadores-atlas-new.7e1e7f68.png";